<template>
    <div class="corpo-etapa">
        <!-- <p>{{ atributoAnteriorCasoItemEditado }}</p> -->
        <div :style="{ paddingInline:marginGeral}" class="itens-da-etapa">
            <h3 class="nome-do-item" >{{ etapa.nome }}</h3>
            <h4 v-if="isCustomerHasChoice" class="texto-selecione" :class="classQtdMax">Selecione {{ isPizza ? "até" : "" }} {{ etapa.qtdeItensEscolhidosNaEtapa }}
                {{ isPizza ? "sabor(es)" :etapa.qtdeItensEscolhidosNaEtapa===1? "item":"itens"}}</h4>
            <div class="div-grafico-pizza" v-if="isPizza && produtoSelecionado.length" :style="{ top: topPosition + 'px', marginTop:marginGeral }">
                <PizzaChart :numeroDivisoes="produtoSelecionado.length" @update-pizza="(i) => { indexEmEvidencia = i; scrollParaItem(i) }" ref="pizzaChart"/>
                <div class="mensagem-ensinar-navegar">
                    <h3 v-if="!mensagemPizzaJaMostrada" class="mensagem-ensinar-navegar-texto">Navegue pelo gráfico para visualizar o resumo do pedido.</h3>
                    <h3 v-if="mensagemPizzaJaMostrada" class="mensagem-ensinar-navegar-texto"> Total R$:{{ totalValorVenda.toFixed(2).replace(".", ",") }}</h3>
                </div>
            </div>
            <div :style="{ gap: marginGeral }" class="div-lista-todos-itens">
                <div v-for="(item, index) in etapa.itens" :key="index" style="height: 100%; display: flex;">
                    <div class="clicable" style="height: 100%; width: 100%;">
                        <!-- caso seja tipo PIZZA (Como era cadastrada antigamente)-->
                        <div v-if="isTipoComboPizza" @click="selecionouSaborPizza(item)" style="height: 100%;">
                            <div :class="produtoSelecionado && produtoSelecionado.some(p => p.item.codigo === item.codigo)  ? 'nome-e-descricao select' : 'nome-e-descricao not-select'">
                                <img class="img-item" :src="'https://fotoscardapio.s3.sa-east-1.amazonaws.com/'+ $store.state.cnpj +'/' + item.codigoItemComponente_FK + '.jpg'" alt="" @error="$event.target.style.display = 'none'">
                                <p class="texto-descricao-completa">{{ item.descricaoCompleta }}</p>
                                <p class="descricao-item">{{ item.observacao }}</p>
                                <h3 class="precoPizza">R$ {{ 
                                qtdSaboresEscolhidosPizza ?
                                        calcularValorFracaoPizza(item.valorVenda).toFixed(2).replace(".", ",") 
                                        : item.valorVenda.toFixed(2).replace(".", ",") }}
                                </h3>
                            </div>
                        </div>
                        

                        <!-- caso NAO seja tipo PIZZA, jeito antigo de cadastrar (etapa fracionada do combo por etapas tbm entra aqui)-->
                        <div v-if="!isTipoComboPizza && isCustomerHasChoice" class="etapas-row">
                            <!-- <h3>{{ $store.state.cnpj }}</h3> -->
                            <!-- <p>{{ etapa }}</p> -->
                            <div class="item-row-div">
                                <div v-if="qtdDesteItemNaLista(item)" class="item-row" @click="adicionarItem(item)" style="position: absolute;padding: 0px;margin: 5px;">
                                    <div class="box-number">
                                        <p>{{ qtdDesteItemNaLista(item) }}</p>
                                    </div>
                                </div>

                                <img @click="adicionarItem(item)" class="img-item" :src="'https://fotoscardapio.s3.sa-east-1.amazonaws.com/'+$store.state.cnpj+'/' + item.codigo + '.jpg'" alt="" @error="$event.target.style.display = 'none'">

                                <div @click="adicionarItem(item)" :style="{paddingBlock:marginGeral}" class="item-content">
                                    <p class="texto-descricao-completa">{{ item.descricaoCompleta }}</p>
                                    <p class="descricao-item">{{ item.observacao }}</p>
                                    <!-- Etapa Fracionada -->
                                    <div v-if="isPizza">
                                        <h3 class="valor-etapa-combo">R$ {{ 
                                            qtdSaboresEscolhidosPizza ?
                                            calcularValorFracaoPizza(item.valorVendaItem).toFixed(2).replace(".", ",") 
                                            : item.valorVendaItem.toFixed(2).replace(".", ",") }}
                                        </h3> 
                                    </div>
                                    <div v-if="!isPizza">
                                        <div v-if="cobrarPorEtapa">
                                            <div v-if="etapa.permiteEscolherMenosItens == '1' && etapa.valorEtapa < item.valorVenda">
                                                <p class="texto-promocao">Promoção</p>
                                                <p class="valor-riscado">
                                                    R$ {{ item.valorVenda.toFixed(2).replace(".", ",") }}
                                                </p>
                                            </div>
                                            <p class="valor-etapa-combo">
                                                R$ {{ etapa.valorEtapa.toFixed(2).replace(".", ",") }}
                                            </p>
                                        </div>
                                        <p v-if="!cobrarPorEtapa" class="valor-etapa-combo">
                                            R$ {{ item.valorVendaItem.toFixed(2).replace(".", ",") }}
                                        </p>
                                    </div>
                                </div>

                                <div v-if="qtdDesteItemNaLista(item)" @click="removerItem(item)" class="botao-trash">
                                    <div>
                                        <img src="../../../assets/icons/ic-trash.png" alt="" style="height: 30px;filter: invert(100%);">
                                    </div>
                                    <h3>Retirar</h3>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   
        <div class="div-resumo-pedido">
            <div v-if="produtoSelecionado.length">
                <p class="titulo-selecionado">{{produtoSelecionado.length==1?"SELECIONADO:":"SELECIONADOS:"}}</p>
                <!-- <p>{{JSON.stringify(produtosFinalizados)}}</p> -->
                <!-- opcoesEscolhidasId , opcoesEscolhidas -->
                <div v-for="(selecionado, index) in produtoSelecionado" :key="selecionado._uid" ref="refsItens">
                    <ProdutoController
                        :ehcombo="true"
                        :item="selecionado.item"
                        :itemIndex="index"
                        :isSaborPizza="isPizza"
                        :qtdSaboresEscolhidos="qtdSaboresEscolhidosPizza"
                        :precoProps="cobrarPorEtapa ? etapa.valorEtapa : null"
                        :mostrarObservacoesDePreparo="true"
                        :atributoAnteriorCasoItemEditado="atributoAnteriorCasoItemEditado[index]"
                        @onClickConfirmarEsteItem="onItemSelecionadoFinalizado"
                    /> 
                </div>
            </div>
        </div>

        <div :style="{padding:marginGeral}" v-if="!isPizza" class="div-botoes-nao-pizza">
            <div :style="{marginRight:marginGeral}" class="button-comum">
                <button @click="removerTodosItems" class="btn-limpar-bottom" :disabled="this.produtoSelecionado.length===0 || !this.isCustomerHasChoice">
                    Limpar itens escolhidos
                </button>
            </div>
            <div class="button-comum btn-avancar-bottom" @click="callbackItem" >
                <EtapasBotaoAvancar 
                :itensNaEtapa="etapa.qtdeItensEscolhidosNaEtapa" 
                :itensRespondidos="this.produtoSelecionado.length" 
                :permiteEscolherMenosItens="etapa.permiteEscolherMenosItens == 1 || etapa.permiteEscolherMenosItens == '1'"
                :perguntasObrigatoriasRepondidas="podeAvancar"
                :isPrimeiraEtapa="indexEtapaCorrente == 0"
                />
            </div>
        </div>
        <div v-if="isPizza" class="div-botao-avancar" >
            <button v-if="podeAvancar" class="botao botao-avancar" @click="callbackItem">
                    <img class="icon-check" src="../../../assets/icons/ic-check.png" alt="">
                    Avançar
            </button>
            <button v-if="!podeAvancar" class="botao botao-desativado">
                    Avançar
            </button>
        </div>
    </div> 
</template>

<script>
import EtapasBotaoAvancar from '@/components/Base/EtapasBotaoAvancar.vue';
import ProdutoController from './controle/ProdutoController.vue';
import PizzaChart from './pizzas/PizzaChart.vue';
// import { setarCores } from '@/utils/SetarCores';

export default {
    name: "CadaEtapa",
    props: {
        indexEtapaCorrente: Number,
        totalEtapas: Number,
        etapa: Object,
        cobrarPorEtapa: Boolean,
        isTipoComboPizza: Boolean,//tipo antigo de cadastrar pizza(Agora usamos o combo por etapas ,com etapa fracionada.)
        atributoAnteriorCasoItemEditado: Array,
    },
    watch: {
        etapa() {
            if (this.atributoAnteriorCasoItemEditado.length) {
                this.produtoSelecionado = this.atributoAnteriorCasoItemEditado.map(e => ({
                    ...e,
                    _uid: this.nextUid++
                }));
                this.produtosFinalizados = [...this.atributoAnteriorCasoItemEditado];
            } else {
                this.produtoSelecionado = [];
                this.produtosFinalizados = [];
            }
        },
         produtoSelecionado: {
            handler() {
                this.setupObserver();
            },
            deep: true
        }
    },
    computed: {
        isPizza() {
             if (this.isTipoComboPizza) return true
             if (this.etapa.comboFracionado && this.etapa.comboFracionado == "1") return true
             return false
        },
        totalValorVenda(){
            let total=0;
            this.produtosFinalizados.map(e=>{
                total=total+e.precoApenasVariacoes;
            });
            this.produtoSelecionado.map(i=>{
                // Caso o item for tipo pizza antigo ele pega valorVenda caso for tipo pizza novo(combo por etapas) ele pega o valorVendaItem
                total=total+this.calcularValorFracaoPizza(this.isTipoComboPizza?i.item.valorVenda:i.item.valorVendaItem);
            })
            return (total)
        },
        qtdSaboresEscolhidosPizza() {
            return this.produtoSelecionado.length
        },

        podeAvancar() {
            if (this.isPizza) {
                if (this.produtoSelecionado.length === 0) return false
                return this.numeroDePerguntasObrigatoriasRespondidas === this.produtoSelecionado.length
            } else {
                // se permite escolher menos itens do que o maximo
                if (this.etapa.permiteEscolherMenosItens == 1 || this.etapa.permiteEscolherMenosItens == "1") {
                    // se permite escolher menos itens e essa é a PRIMEIRA etapa, o usuario é obrigado a escolher
                    // pelo menos um item. Se for da segunda etapa pra frente, o usuario pode escolher
                    // nenhum item e ir para a proxima etapa
                    if (this.indexEtapaCorrente == 0) { // se for a primeira etapa
                        if (this.numeroDePerguntasObrigatoriasRespondidas == parseInt(this.produtoSelecionado.length) && this.produtoSelecionado.length > 0) {
                            return true
                        }
                        return false
                    } else {
                        if (this.numeroDePerguntasObrigatoriasRespondidas == parseInt(this.produtoSelecionado.length)) {
                            return true
                        }
                        console.log(this.produtoSelecionado.length)
                        console.log(this.numeroDePerguntasObrigatoriasRespondidas)
                        console.log('deu problema aqui')
                        return false
                    }
                        
                } 
                
                // caso tenha que escolher exatamente o numero maximo de itens
                else {
                    
                    if (this.produtoSelecionado.length == this.etapa.qtdeItensEscolhidosNaEtapa) {
                        if (this.numeroDePerguntasObrigatoriasRespondidas == parseInt(this.etapa.qtdeItensEscolhidosNaEtapa)) {
                            return true
                        }
                        return false
                    }
                    return false
                }
            }
        },

        numeroDePerguntasObrigatoriasRespondidas() {
            let lista= this.produtosFinalizados.filter((i) => i.podeAvancar);
            // let lista2 = this.produtosFinalizados.length;
            return lista.length
        },

        computedPizzaSaborMaisCaro() { 
            if(!this.isTipoComboPizza){//novo jeito de cadastrar pizza(Combo por etapas)
                // Sort the array by price in descending order
                let newarray = [...this.produtoSelecionado];
                newarray.sort((a, b) => Number(b.item.valorVendaItem) - Number(a.item.valorVendaItem));
                // Get the highest price
                const precoMaisAlto = newarray[0].item.valorVendaItem;
                return precoMaisAlto
            }
            else{//antigo jeito de cadastrar pizza (Combo tipo pizza)
                // Sort the array by price in descending order
                let newarray = [...this.produtoSelecionado];
                newarray.sort((a, b) => Number(b.item.valorVenda) - Number(a.item.valorVenda));
                // Get the highest price
                const precoMaisAlto = newarray[0].item.valorVenda;
                return precoMaisAlto
            }
        }

        

    },
    data() {
        return {
            nextUid: 0,
            // isPizza: true,
            topPosition: 0,
            topBarHeight: 0,
            topBarHasImage: false,
            marginGeral:"15px",
            classQtdMax: 'qtd-max',
            produtoSelecionado: this.atributoAnteriorCasoItemEditado?this.atributoAnteriorCasoItemEditado : [],
            produtosFinalizados: [],
            indexEmEvidencia:-1,
            observer: null,
            mensagemPizzaJaMostrada:false,
            isCustomerHasChoice: !(this.etapa.qtdeItensEscolhidosNaEtapa === 1 && this.etapa.permiteEscolherMenosItens === '0' && this.etapa.itens.length === 1),
        };
    },
    mounted(){
        this.produtoSelecionado = this.produtoSelecionado.map(e => ({
            ...e,
            _uid: e._uid != null ? e._uid : this.nextUid++
        }));
        if (this.isPizza) {
            window.addEventListener("scroll",this.updatePosition);
            window.addEventListener("resize", this.updateTopBarHeight);
            if(this.atributoAnteriorCasoItemEditado.length) {
                console.log("entrou no if do watch da etapa e isPizza é true")
                this.vericaSeEscolheuPizzaPelaPrimeiraVez();
            }
            this.updateTopBarHeight();
        }
        this.setupObserver();
        this.verificaSeClienteTemEscolha();
    },
    beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
      }
    },
    beforeUnmount() {
        if (this.isPizza) {
            window.removeEventListener("scroll",this.updatePosition);
            window.removeEventListener("resize", this.updateTopBarHeight);
        }
    },
    created() {
        this.created()
    },
    methods: {
        created() {
            // console.log(this.etapa)
        },
        updateTopBarHeight() {
            if (!this.isPizza) return;
            this.$nextTick(() => {
                const root = this.$el.closest('.backgrounds');
                const topBar = root ? root.querySelector('.top-bar') : document.querySelector('.top-bar');
                const topBarImage = topBar ? topBar.querySelector('#mercadoriaImg') : null;
                this.topBarHasImage = Boolean(topBarImage && topBarImage.src && topBarImage.src.length > 0 && topBarImage.style.display !== 'none');
                this.topBarHeight = this.topBarHasImage ? topBarImage.offsetHeight : 0;

                if (topBarImage && !topBarImage.complete) {
                    topBarImage.addEventListener('load', this.updateTopBarHeight, { once: true });
                }

                this.updatePosition();
            });
        },
        /**
         * APENAS PARA PIZZAS
         * 
         * Vai adicionar o sabor, ou retirar, ja que nao vamos adicionar 2/3 de um sabor e 1/3 de outro.
         * Ou seja, nao podemos selecionar duas vezes o mesmo sabor
         * @param {*} item
         */
        selecionouSaborPizza(item) {
            
            let itemPreFinalizado = {
                _uid: this.nextUid++,
                podeAvancar: item.podeAvancar ?? false,
                item: item,
                perguntasForcadas : [],
                itemsRetirar      : [],
                itemsAdicionar    : [],
            }

            let index = this.produtoSelecionado.findIndex(i => i.item.codigo == item.codigo)
            if (index == -1) {
                
                if (this.produtoSelecionado.length !== parseInt(this.etapa.qtdeItensEscolhidosNaEtapa) ) {
                    this.vericaSeEscolheuPizzaPelaPrimeiraVez();
                    this.produtoSelecionado.push(itemPreFinalizado);
                } else {
                    this.animarQuantidadeMaxAtingida()
                }

                // Quando escolhe o maximo ele scrolla para o primeiro item
                if(this.produtoSelecionado.length === parseInt(this.etapa.qtdeItensEscolhidosNaEtapa)){
                    this.scrollParaItem(0);
                }
            } else {
                this.produtoSelecionado = this.produtoSelecionado.filter(i => i.item.codigo !== item.codigo);
                this.produtosFinalizados = this.produtosFinalizados.filter((i) => i.item.codigo !== item.codigo)
            }
            this.atualizarPrecoVariacaoFichasTecnicasEscolhidas()
        },
        /**
         * função para recalcular o preço da variação da ficha tecnica.(O valor dos itens da ficha tecnica variam dependendo da quantidade de sabor escolhida.)
         */
        atualizarPrecoVariacaoFichasTecnicasEscolhidas(){
            this.produtosFinalizados.map(p=>{
                let precoApenasVariacoesTotal=0;//Soma do preco de todas as variacoes atualizada.
                if(p.adicionar.length){//vamos verificar se tem ficha tecnica escolhida nesse sabor de pizza
                    p.adicionar.map(f=>{//mapeamos todas as fichas tecnicas existentes
                        f.opcoesEscolhidasId.map((c,i)=>{//pegamos o codigo da ficha tecnica adicionada c e o index i
                            p.item.variacaofichatecnica.map(v=>{
                                v.opcoes.map((cadaVaria) =>{
                                    if(cadaVaria.codigo===c){//vamos verificar se o cod da variacao eh igual ao codigo da variacao da ficha tecnica adicinada
                                        f.opcoesEscolhidas[i].preco=(cadaVaria.valorAdicionais/this.produtoSelecionado.length)
                                        precoApenasVariacoesTotal=precoApenasVariacoesTotal+cadaVaria.valorAdicionais/this.produtoSelecionado.length;
                                
                                    }   
                                })
                            })
                        })
                    })
                    p.precoApenasVariacoes=precoApenasVariacoesTotal;
                }
            })
        },

        // desconecta qualquer observer anterior
        setupObserver() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        //fica vendo qual sabor esta na tela no momento
        this.$nextTick(() => {
            const nodes = [].concat(this.$refs.refsItens || []);
            if (!nodes.length) {
            return;
            }
            this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const index = nodes.indexOf(entry.target);
                    if (index !== -1) {
                    this.atualizarIndexPeloScroll(index);
                    }
                } else {
                    this.atualizarIndexPeloScroll(-1);//nenhum está visivel
                }
                });
            }, 
            {
                root: null,
                threshold: 0.4, // 40% do item visível
            }
            );
            nodes.forEach(el => {
            if (el) this.observer.observe(el);
            });
        });
        },
        //Atualizar qual pizza esta em evidencia quando o cliente scrolla
        atualizarIndexPeloScroll(index) {
        if (this.indexEmEvidencia !== index) {
            this.indexEmEvidencia = index;
            if (this.$refs.pizzaChart && this.$refs.pizzaChart.pizzaChart) {
                const valores = Array(this.produtoSelecionado.length).fill(1);
                this.$refs.pizzaChart.pizzaChart.data.datasets[0].offset = valores.map((_, i) =>
                    i === index ? 20 : 0
                );
                this.$refs.pizzaChart.pizzaChart.update();
            }
        }
        },
        //posição do grafico pizza na tela
        updatePosition(){
            if (!this.isPizza) return;
            const extraOffset = this.topBarHasImage ? 0 : 130;
            this.topPosition = window.scrollY - this.topBarHeight - extraOffset;
        },
        calcularValorFracaoPizza(valorIntegral) { 
            let cobrarMaior = this.$store.state.pizzaCobrarMaior;
            if (cobrarMaior == false) {
                return (1 / this.qtdSaboresEscolhidosPizza) * valorIntegral
            } else {
                if (this.qtdSaboresEscolhidosPizza < 2) {
                    return (1 / this.qtdSaboresEscolhidosPizza) * valorIntegral
                }
                return (1 / this.qtdSaboresEscolhidosPizza) * Number(this.computedPizzaSaborMaisCaro)
            }
        },
        //usado para ensinar o cliente a usar o grafico como botao(dura por 6 segundos)
        vericaSeEscolheuPizzaPelaPrimeiraVez(){
            setTimeout(()=>{
                this.mensagemPizzaJaMostrada=true;
            },10000)
        },


        /**
         *  APENAS COMBO POR ETAPA
         *  Adicioanr itens na lista. Aqui podemos colocar dois itens iguas.
         */
        adicionarItem(item) {
            if (this.produtoSelecionado.length < this.etapa.qtdeItensEscolhidosNaEtapa) {

                let itemPreFinalizado = {
                    _uid: this.nextUid++,
                    podeAvancar: false,
                    item: item,
                    perguntasForcadas : [],
                    itemsRetirar      : [],
                    itemsAdicionar    : [],
                }
                this.produtoSelecionado.push(itemPreFinalizado);
                if (this.produtoSelecionado.length === this.etapa.qtdeItensEscolhidosNaEtapa && this.isCustomerHasChoice) {
                    this.scrollParaItem(0);
                }
            } else {
                this.animarQuantidadeMaxAtingida();
            }
            if(this.isPizza){
                this.vericaSeEscolheuPizzaPelaPrimeiraVez();
                this.atualizarPrecoVariacaoFichasTecnicasEscolhidas();
            }
            // this.produtosFinalizados.push(itemPreFinalizado);
        },

        /**
         *
         * Remover item da lista. Pode haver dois itens iguais na lista, entao retiramos um deles apenas.
         */
        removerItem(item) {
            let index = this.produtoSelecionado.findIndex(i => i.item.codigo == item.codigo)
            if (index !== -1) {
                this.produtoSelecionado.splice(index, 1);
            }

            let index2 = this.produtosFinalizados.findIndex(i => i.item.codigo == item.codigo)
            if (index2 !== -1) {
                this.produtosFinalizados.splice(index, 1);
            }
            if(this.isPizza){
                this.atualizarPrecoVariacaoFichasTecnicasEscolhidas();
            }
        },
        /**
         * APENAS COMBO POR ETAPA
         * Remove todos os itens selecionados
         */
        removerTodosItems(){
            this.produtoSelecionado= [];
            this.produtosFinalizados=[];
        },

        qtdDesteItemNaLista(item) {
            if (item != null) {
                const theseItems = this.produtoSelecionado.filter(i => i.item.codigo == item.codigo);
                return theseItems.length;
            }
            return 0
        },

        animarQuantidadeMaxAtingida() {
            window.scrollTo(0, 0);
            this.classQtdMax = 'qtd-max-anim'
            setTimeout(() => {
                this.classQtdMax = 'qtd-max'
            }, 1000);
        },



        /**
         * Vai adicionar o item finalizado na @see this.produtosFinalizados . Caso o item ja esteja la,
         * vai apagar ele de la e adicionar o novo
         * @param {*} item 
         */
        onItemSelecionadoFinalizado(item, itemIndex) {
            let itemPreFinalizado = item

            // se esta etapa for uma etapa fracionada, entao estamos escolhendo sabores de pizza aqui. neste caso, vamos pegar o @item
            // que chega aqui como param e adicionar a flag "fracionado".
            if (this.etapa.comboFracionado =="1" || this.etapa.comboFracionado == 1 || this.etapa.comboFracionado == true) {
                itemPreFinalizado.fracionado = true
            } else {
                itemPreFinalizado.fracionado = false
            }
            
            if (this.produtosFinalizados[itemIndex] == null) {
                this.produtosFinalizados.push(itemPreFinalizado)
            } else {
                let placeeholder = this.produtosFinalizados
                this.produtosFinalizados = [];
                this.produtosFinalizados = placeeholder;
                this.produtosFinalizados[itemIndex] = itemPreFinalizado;
            }
        },

        /**
         * Enviar para o parent o item selecionado
         * @param {*} item
         */
        callbackItem() {
            if (this.podeAvancar) {
                this.isCustomerHasChoice=true;
                let produtosFinalizadosFracoesArrumadas = this.arrumarFracoes()
                this.$emit("onSelectedItems", produtosFinalizadosFracoesArrumadas);
            }      
        },

        /**
         * Contamos quantos itens tem na mesma etapa caso a etapa seja fracionada, e assim, podemos adicionar o atributo
         * @fracaoQuantidade = ex "3" no item e devolve-lo.
         * Alem disso, vai arrumar o preco do item pra fracionar tbm.
         */
        arrumarFracoes() {
            if (this.etapa.comboFracionado =="1" || this.etapa.comboFracionado == 1 || this.etapa.comboFracionado == true) {
                let maiorPreco = 0.0  // apenas para guardar o valor do preco do sabor mais caso, apra ser usado caso esteja confugrado para cobrar pelo valor maior
                for (const prod of this.produtosFinalizados) {
       
                    prod.fracaoQuantidade = this.produtosFinalizados.length
                    prod.valorUnitarioPagoNoSmartPos = prod.valorUnitarioPagoNoSmartPos / this.produtosFinalizados.length

                    // apenas para guardar o valor do preco do sabor mais caso, apra ser usado caso esteja confugrado para cobrar pelo valor maior
                    if (Number(prod.preco) > maiorPreco) maiorPreco = prod.preco
                    // if (prod.valorUnitarioPagoNoSmartPos > maiorPreco) maiorPreco = prod.valorUnitarioPagoNoSmartPos
    

                    console.log("prod aqui antes")
                    console.log(prod)
                }

                // caso esteja configurado para cobrar pelo maio preco nas configuracoes globais, vamos iterar novamente
                // para aletar os precos
                if (this.$store.state.pizzaCobrarMaior) {
                    for (const prod of this.produtosFinalizados) {
        
                        prod.precoTotal = maiorPreco + (prod.precoApenasVariacoes *prod.fracaoQuantidade)
                        prod.preco = maiorPreco 
                        prod.precoSaborMaisCaro = maiorPreco
                        // prod.valorUnitarioPagoNoSmartPos = (maiorPreco  + (prod.precoApenasVariacoes * prod.fracaoQuantidade) ) / this.produtosFinalizados.length 
                        // prod.valorUnitarioPagoNoSmartPos =maiorPreco / this.produtosFinalizados.length
                        prod.precoApenasVariacoes =prod.precoApenasVariacoes *prod.fracaoQuantidade
                                                
                        console.log("prod aqui depois")
                        console.log(prod)

                    }
                }
            }

            console.log(this.produtosFinalizados)

            // this.$store.commit('SET_PIZZA_SABOR_MAIS_CARO_OBJ', {id: this.produtosFinalizado.id, preco : maiorPreco})
            
            return this.produtosFinalizados
        },

        scrollParaItem(index) {
            this.$nextTick(() => {
            const el = this.$refs.refsItens[index]; // assume que você usou ref="refsItens"
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' }); 
            }
            });
        },
        /**
         * Verifica se numero maximo de itens possiveis nessa etapa eh 1 e temos apenas 1 item disponivel e nao permite escolher menos que o limite.
         * Isso significa que o cliente não tem escolha, a função adiciona o item como se o cliente tivesse escolhido.
         */
        verificaSeClienteTemEscolha(){
            if(!this.isCustomerHasChoice){
                this.adicionarItem(this.etapa.itens[0]);
            }
            console.log('O cliente nao tinha escolha, o item foi adicionado automaticamente')
        },
    },
    components: { PizzaChart, ProdutoController, EtapasBotaoAvancar }
}
</script>

<style scoped>
.corpo-etapa {
    margin: 0;
    overflow-x: hidden;
    background: white;
}

.itens-da-etapa {
    background: white;
    margin-left: 0;
    padding-block: 10px;
}

.itens-da-etapa > .nome-do-item{
    color: black;
}
.itens-da-etapa > .texto-selecione{
    color: black;
    padding-bottom: 10px;
}

p {color: black; margin: 0;}

.img-item{
    object-fit: cover;
    max-height: 100px;
    border-top-left-radius: var(--border-radius-padrao);
    border-top-right-radius: var(--border-radius-padrao);
    width: 100%;
}

.etapas-row {
    width: 100%;
    display: flex; 
    justify-content: space-between; 
    align-items: stretch;
    height: 100%;
    border-radius: var(--border-radius-padrao);
    font-weight: bold;
}
.div-lista-todos-itens{
    display: grid;
    grid-template-columns: repeat(2,1fr);
    align-items: stretch;
}
.item-row-div{
    border: solid 2px var(--cor1-escura);
    width: 100%;
    border-radius: var(--border-radius-padrao);
    background: whitesmoke;
    display: flex;
    flex-direction: column;
    height: 100%;
}

.item-row .nome-e-descricao {
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.item-row {
    font-size: 0.8rem;
    line-height: 1.1rem;
    color: rgba(205,205,205);
    text-align: center;
    font-weight: bold;
}
.texto-descricao-completa{
    padding-top: var(--padding-padrao);
    font-weight: bold;
    font-size: 1.1em;
    min-height: 30px;
}
.descricao-item{
    text-align: start;
    padding-inline: 10px;
    margin: 0px;
    font-weight: 300;
    font-size: 0.6rem;
    word-break: break-word;
    overflow-wrap: break-word;
}

.qtd-max {
    
}
.qtd-max-anim {
    animation: qtd-max-animation 1s forwards;
}

@keyframes qtd-max-animation {
    0%, 100%                 { transform: translateX(0%); background: none }
    10%, 30%, 50%, 70%, 90%  { transform: translateX(-2%); background: red}
    20%, 40%, 60%, 80%       { transform: translateX(2%); background: red}
}

.btn-avancar {
    display: flex;
    justify-content:space-evenly;
    padding-block: 15px;
    /* padding-block: 10px; */
    border-radius: var(--border-radius-padrao);
    width: 100%;
}

.desativado {
    background: rgb(100, 100, 100);
    color: rgb(75, 75, 75);
}

.div-botoes-nao-pizza{
    display: flex;
    justify-content: space-evenly;
    background: white;
}
.valor-etapa-combo{
    color: green;
    padding-top: 5px;
    font-weight: bold;
    font-size: 1.1em;
}
.button-comum{
    border-radius: var(--border-radius-padrao);
    width: 100%;
    position: sticky;
    bottom: 0;
    left: 0;
}
.btn-limpar-bottom {
    background: var(--azul-claro);
    color: white;
    width: 100%;
    height: 100%;
    font-size: 1.2em;
    border-radius: var(--border-radius-padrao);
}
.btn-limpar-bottom:disabled{
    background: var(--cinza-escuro);
}

.btn-avancar-bottom {
    background: linear-gradient(to bottom, green, #2F4538);
}

.div-resumo-pedido{
    background: whitesmoke;
    padding-bottom: 10px;
}
.botao-trash{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 35px;
    background: red;
    border-bottom-left-radius:var(--border-radius-padrao);
    border-bottom-right-radius: var(--border-radius-padrao);
}

/* ----------------------------------------------------------------------- APENAS PARA PIZZAS */
.div-grafico-pizza{
    z-index: 1;
    position: fixed;
    display: flex;
}
.div-grafico-pizza>.mensagem-ensinar-navegar{
    width: 200px;
    align-items: center;
    display: flex;
    margin-left: 10px;
    height: auto;
}
.mensagem-ensinar-navegar-texto{
    background: black;
    padding: 10px;
    border-radius: var(--border-radius-padrao);
}

.pizza-row {
    display: flex;
    justify-content: space-between;
}
.pizza-row-precos {

}
.precoPizza{
    font-weight: bold;
    font-size: 1.1em;
    padding-bottom: 15px;
} 
.pizza-row-selecionado {
    background: rgba(255, 255, 255, 0.1);
}
.not-select{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    border: 2px solid var(--cor1-escura);
    border-radius: var(--border-radius-padrao);
    background: whitesmoke;
    height: 100%;
}

.nome-e-descricao>h3 {
    margin-top: auto;
}
 .not-select>h3{
    color: green;
 }
.select{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    border: 2px solid var(--verde-claro);
    border-radius: var(--border-radius-padrao);
    background: var(--verde-claro);
    height: 100%;
}
/* .select>.div-inf>p,h3,.select>p{
    color: white;
} */
.select>p,h3{
    color: white;
}
.preco-pizza-integral {
    text-align: end;
}
.preco-pizza-integral-inativo {
    opacity: 0.6;
    font-size: 0.9rem;
    text-align: end;
    margin-bottom: 4px;
}
.preco-pizza-fracao {
    background: var(--verde-claro);
    animation: preco-pizza-fracao-anim 0.5s forwards;
    /* text-align: end;
    font-size: 0.9rem; */
    color: rgba(255,255,255, 0.8);
}
@keyframes preco-pizza-fracao-anim {
    from { opacity: 0; transform: translateY(30%); }
    to   { opacity: 1; transform: translateY(0%); }
}

.box-number {
    border-radius: 50%;
    background:var(--cor1) ;
    border: solid 1px var(--cor1-escura);
    height: 25px;
    width: 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 10px;
}
.box-number p {
    margin: 0;
    font-size: 0.8rem;
    color: var(--cor-texto);
}

.titulo-selecionado{
    color:black;
    font-weight: 900;
    font-size: 0.8em;
    padding-top: 10px;
}

.div-botao-avancar{
    margin: 15px;
}
.botao{
    width: 100%;
    height: 50px;
    border-radius: var(--border-radius-padrao);
    font-weight: bold;
    display:flex;
    align-items: center;
    justify-content: center;
    color: white;
}
.botao-avancar{
    background: var(--gradiente-verde);
}
.botao-desativado{
    background: var(--gradiente-desabilitado);
}
.icon-check{
    height: 25px;
    width: 25px;
    left: 30%;
    position: absolute;
    filter: invert(100%);
}
.texto-promocao{
    padding-top: 5px;
    color: var(--cinza-escuro);
    font-size: 1.2em;
}
.valor-riscado{
    font-size: 1.2em;
    text-decoration-line: line-through;
    color: var(--cinza-escuro);
}
.item-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
</style>